<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent :maxWidth="850">
      <LoaderDialog :activeDialog="loaderConfirm" />
      <v-card>
        <v-card-title class="mt-3 text-h5 primary white--text">
          Termos
        </v-card-title>
        <v-card-text class="subtitle-1 mt-5">
          Para realizar parcelamentos é necessario ler e aceitar nossos termos
          de uso.
        </v-card-text>
        <v-card-text class="subtitle-1 mt-5">
          <div class="mt-5">
            <div class="d-flex g-3 align-items-center">
              <v-checkbox
                class="ma-0"
                v-model="checkboxTermos"
                :label="`Declaro que li e aceito os termos de`"
                hide-details
              ></v-checkbox>
              <a
                :href="pdfTermoAceiteParcelamento"
                :title="'TERMO DE ADESÃO AO PARCELAMENTO DE DÉBITOS'"
                :class="'button text-decoration-underline'"
                target="_blank"
                rel="noopener noreferrer"
                style="margin-top: 2px; margin-left: 5px !important"
              >
                adesão ao parcelamento de débitos.
              </a>
            </div>
            <vue-recaptcha
              ref="recaptcha"
              :sitekey="siteKey"
              :loadRecaptchaScript="true"
              @verify="verifyRecaptcha"
              @expired="expiredRecaptcha"
              class="recaptcha mt-5"
            ></vue-recaptcha>
            <v-input v-model="recaptcha" :rules="[rules.required]"></v-input>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="backPageServices()">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="aceitarTermos()"
            :loading="loaderConfirm"
            :disabled="!checkboxTermos"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import { router } from "@/router";
import Vue from "vue";
import { mapState } from "vuex";
import newNegociationService from "@/services/financeiro/new-negociation.service";
import VueRecaptcha from "vue-recaptcha";
import LoaderDialog from "./LoaderDialog.vue";
import GlobalStore from "@/store/modules/global";

export default Vue.extend({
  name: "AceiteTermosParcelamento",
  props: {},
  components: { VueRecaptcha, LoaderDialog },
  data: () => {
    return {
      dialog: false,
      checkboxTermos: false,
      pdfTermoAceiteParcelamento:
        process.env.BASE_URL + "TERMO DE ADESÃO AO PARCELAMENTO DE DÉBITOS.pdf",
      siteKey: VUE_APP_RECAPTCHA_KEY,
      rules: {
        required: (value) => !!value || "Esse campo deve ser preenchido",
      },
      recaptcha: null,
      loaderConfirm: false,
    };
  },
  methods: {
    verifyRecaptcha(value) {
      this.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.recaptcha = null;
    },
    backPageServices() {
      router.push({ name: "servicos-transportes" });
    },
    aceitarTermos() {
      this.loaderConfirm = true;
      newNegociationService
        .aceitarTermosParcelamento(
          this.transportadora.cnpj,
          this.transportadora.numOrdem.toString(),
          true,
          this.recaptcha
        )
        .subscribe(
          (res) => {
            this.dialog = false;
            GlobalStore.setSnackBar({
              show: true,
              message: "Requisição realizada com sucesso",
              type: "success",
            });
          },
          (error) => {
            this.loaderConfirm = false;
            GlobalStore.setSnackBar({
              show: true,
              message: "Não foi realizar a requisição",
              type: "error",
            });
          }
        );
    },
    checkAceiteTermos() {
      newNegociationService
        .checkAceiteTermosParcelamento(
          this.transportadora.cnpj,
          this.transportadora.numOrdem.toString(),
          true
        )
        .subscribe(
          (res) => {
            this.dialog = !res;
          },
          (error) => {
            console.log(error);
          }
        );
    },
  },
  computed: {
    ...mapState("transportadora", ["transportadora"]),
  },
  mounted() {
    this.checkAceiteTermos();
  },
});
</script>
